import React, { useCallback, useEffect, useState } from "react";
import eVoucherApi from "../../api/eVoucherApi";

import "./style.scss";

const defaultForm = {
  prefix: "TCB_",
  quantity: 10,
  discountType: "amount",
  value: 10000,
  note: "",
  expiredAt: "",
};

function formatDate(value) {
  if (!value) return "";
  return new Date(value).toLocaleString("vi-VN");
}

function formatValue(item) {
  if (item.discountType === "percent") {
    return `${item.value}%`;
  }
  return Number(item.value || 0).toLocaleString("vi-VN") + "đ";
}

export default function EVoucher() {
  const [form, setForm] = useState(defaultForm);
  const [filters, setFilters] = useState({
    q: "",
    status: "",
    discountType: "",
    prefix: "",
  });
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [message, setMessage] = useState("");

  const updateForm = (key, value) => {
    setForm((current) => ({ ...current, [key]: value }));
  };

  const updateFilter = (key, value) => {
    setFilters((current) => ({ ...current, [key]: value }));
  };

  const loadEVouchers = useCallback(() => {
    eVoucherApi.list(filters).then((res) => {
      setItems(res.items || []);
      setTotal(res.total || 0);
    });
  }, [filters]);

  useEffect(() => {
    loadEVouchers();
  }, [loadEVouchers]);

  const handleSearch = () => {
    loadEVouchers();
  };

  const handleCreate = () => {
    setMessage("");
    eVoucherApi
      .bulkCreate({
        ...form,
        prefix: form.prefix.toUpperCase(),
        quantity: Number(form.quantity),
        value: Number(form.value),
        expiredAt: form.expiredAt ? new Date(form.expiredAt).toISOString() : "",
      })
      .then((res) => {
        setMessage(`Đã tạo ${res.total || 0} evoucher.`);
        loadEVouchers();
      });
  };

  const handleExport = () => {
    const prefix = filters.prefix.trim() || form.prefix.trim();
    eVoucherApi.exportByPrefix(prefix);
  };

  return (
    <div className="e-voucher">
      <div className="title">E Voucher</div>

      <div className="content">
        <h3>Tạo hàng loạt E Voucher</h3>
        <div className="form">
          <div className="row">
            <div className="form-item">
              <span className="form-label">Prefix</span>
              <input
                className="form-input"
                value={form.prefix}
                onChange={(event) => updateForm("prefix", event.target.value)}
                placeholder="TCB_"
              />
            </div>

            <div className="form-item">
              <span className="form-label">Số lượng</span>
              <input
                className="form-input"
                type="number"
                min="1"
                max="1000"
                value={form.quantity}
                onChange={(event) => updateForm("quantity", event.target.value)}
              />
            </div>

            <div className="form-item">
              <span className="form-label">Loại giá trị</span>
              <select
                value={form.discountType}
                onChange={(event) => updateForm("discountType", event.target.value)}
              >
                <option value="amount">Số tiền</option>
                <option value="percent">Phần trăm</option>
              </select>
            </div>

            <div className="form-item">
              <span className="form-label">Giá trị</span>
              <input
                className="form-input"
                type="number"
                min="1"
                value={form.value}
                onChange={(event) => updateForm("value", event.target.value)}
              />
            </div>

            <div className="form-item">
              <span className="form-label">Hạn active cuối cùng</span>
              <input
                className="form-input"
                type="datetime-local"
                value={form.expiredAt}
                onChange={(event) => updateForm("expiredAt", event.target.value)}
              />
            </div>
          </div>

          <div className="form-item note-field">
            <span className="form-label">Ghi chú áp dụng cho tất cả mã</span>
            <textarea
              rows="3"
              value={form.note}
              onChange={(event) => updateForm("note", event.target.value)}
            />
          </div>

          <div className="form-btn">
            <button className="btn" onClick={handleCreate}>
              Tạo E Voucher
            </button>
            {message && <span className="success-message">{message}</span>}
          </div>
        </div>
      </div>

      <div className="content">
        <div className="list-heading">
          <h3>Danh sách E Voucher</h3>
          <span>{total} mã</span>
        </div>

        <div className="form filters">
          <div className="row">
            <div className="form-item">
              <span className="form-label">Prefix</span>
              <input
                className="form-input"
                value={filters.prefix}
                onChange={(event) => updateFilter("prefix", event.target.value)}
                placeholder="TCB_"
              />
            </div>

            <div className="form-item">
              <span className="form-label">Tìm kiếm</span>
              <input
                className="form-input"
                value={filters.q}
                onChange={(event) => updateFilter("q", event.target.value)}
                placeholder="Mã hoặc ghi chú"
              />
            </div>

            <div className="form-item">
              <span className="form-label">Trạng thái</span>
              <select
                value={filters.status}
                onChange={(event) => updateFilter("status", event.target.value)}
              >
                <option value="">Tất cả</option>
                <option value="inactive">Chưa active</option>
                <option value="active">Đã active</option>
              </select>
            </div>

            <div className="form-item">
              <span className="form-label">Loại giảm</span>
              <select
                value={filters.discountType}
                onChange={(event) => updateFilter("discountType", event.target.value)}
              >
                <option value="">Tất cả</option>
                <option value="amount">Số tiền</option>
                <option value="percent">Phần trăm</option>
              </select>
            </div>
          </div>

          <div className="form-btn">
            <button className="btn" onClick={handleSearch}>
              Lọc dữ liệu
            </button>
            <button className="btn secondary-btn" onClick={handleExport}>
              Xuất Excel theo Prefix
            </button>
          </div>
        </div>

        <div className="evoucher-table-wrap">
          <table className="evoucher-table">
            <thead>
              <tr>
                <th>Mã</th>
                <th>Giá trị</th>
                <th>Trạng thái</th>
                <th>Hạn active</th>
                <th>Ngày active</th>
                <th>Ghi chú</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item) => (
                <tr key={item._id || item.code}>
                  <td className="code-cell">{item.code}</td>
                  <td>{formatValue(item)}</td>
                  <td>
                    <span className={`status ${item.status}`}>
                      {item.status === "active" ? "Đã active" : "Chưa active"}
                    </span>
                  </td>
                  <td>{formatDate(item.expiredAt)}</td>
                  <td>{formatDate(item.activatedAt)}</td>
                  <td>{item.note}</td>
                </tr>
              ))}
              {!items.length && (
                <tr>
                  <td colSpan="6" className="empty-cell">
                    Không có evoucher phù hợp.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
